import Page from 'component/page-container'
import { Route, Switch, NavLink, Redirect } from 'react-router-dom'
import StatProcess from "./stat-process"
import StatPeople from "./stat-people"
import './style.css'


const StatRoute = () => (
    <Page className="stat-page" h1="Статистика">
        <div className="container">
            <div className="nav__menu">
                <NavLink to="/stat/people" exact className="nav__menu-item" activeClassName="menu-item_active">Люди</NavLink>
                <NavLink to="/stat/process" exact className="nav__menu-item" activeClassName="menu-item_active">Процессы</NavLink>
            </div>
        </div>
        <Switch>
            <Route exact path='/stat'><Redirect to="/stat/people" /></Route>
            <Route exact path='/stat/people' component={StatPeople} />
            <Route exact path='/stat/process' component={StatProcess} />
        </Switch>
    </Page>
)

export default StatRoute
